import styled from '@emotion/styled';
import { css } from '@emotion/react';

// @ts-nocheck
const BoxInputOuterContainer = styled.div `
    margin: 10px 0;
    position: relative;
`;
// Expose styles for use with DR elements and autofill
const activateLabel = (isActive) => {
    return isActive
        ? `
        font-size: 11px;
        top: 7px;
        left: 13px;
    `
        : `
        font-size: 15px;
        top: 18px;
        left: 13px;

        &:lang(ja-jp),
        &:lang(ko-kr),
        &:lang(zh-cn),
        &:lang(zh-tw) {
            top: 0.85em;
        }
    `;
};
const inputElementStyles = ({ isActive, disabled, hasError, theme }) => {
    if (disabled) {
        return css `
            background-color: ${theme.colors.textBox.disabled.bg};
            border-color: ${theme.colors.textBox.disabled.border};
            color: ${theme.colors.textBox.disabled.text};
        `;
    }
    else if (hasError) {
        return css `
            background-color: ${theme.colors.textBox.error.bg};
            border-color: ${theme.colors.textBox.error.border};
            color: ${theme.colors.textBox.error.text};
        `;
    }
    else if (isActive) {
        return css `
            background-color: ${theme.colors.textBox.valid.bg};
            border-color: ${theme.colors.textBox.valid.border};
            color: ${theme.colors.textBox.valid.text};
        `;
    }
    else {
        return css `
            background-color: ${theme.colors.textBox.inactive.bg};
            border-color: ${theme.colors.textBox.inactive.border};
            color: ${theme.colors.textBox.inactive.text};
        `;
    }
};
// NOTE: derivatives of BoxInputContainer must include 'input-el' css class for primary input element.
// IE keeps ignoring comma selector ">input, >div" so using .input-el class
const BoxInputContainer = styled.div `
    position: relative;

    ${({ disabled }) => disabled &&
    `
        pointer-events: none;
    `}

    > .input-el {
        ${(props) => inputElementStyles(props)}
        border-width: 1px;
        border-style: solid;
        border-width: ${({ hasError }) => (hasError ? "2px" : "1px")};
        border-radius: 0;
        padding-top: ${({ hasLabel }) => (hasLabel ? "1.4em" : "0.6em")};
        padding-right: ${({ hasIcon }) => (hasIcon ? "3em" : "1em")};
        padding-bottom: 11px;
        padding-left: 12px;
        display: block;
        font-size: 15px;
        height: 50px;
        width: 100%;
        outline: none;
        appearance: none;

        &:-webkit-autofill + label {
            // chrome set a background color to light blue, making labels black for visibility
            color: #1a1a1a !important;
            ${({ disabled, theme }) => activateLabel(theme)}
        }

        ::-ms-clear {
            display: none;
        }

        &:focus {
            padding-left: 11px;
            background-color: ${({ theme }) => theme.colors.textBox.focused.bg};
            color: ${({ theme }) => theme.colors.textBox.focused.text};
            border-color: ${({ theme }) => theme.colors.textBox.focused.border};
            border-width: 2px;
        }
    }

    > img {
        position: absolute;
        top: 50%;
        right: 0.5em;
        transform: translateY(-50%);
        width: 100%;
        height: auto;
        max-width: 2.35em;
        max-height: 2.35em;
    }

    &:hover {
        > .input-el {
            border-width: 2px;
            border-color: ${({ disabled, hasError, theme }) => {
    if (disabled) {
        return theme.colors.textBox.disabled.border;
    }
    else if (hasError) {
        return theme.colors.textBox.error.border;
    }
    else {
        return theme.palette.primary[0];
    }
}};

            &:not(.DRElement) {
                padding-left: 11px;
            }
        }
    }
`;
const BoxInputError = styled.label `
    color: ${({ theme }) => theme.palette.error[3]};
    display: block;
    font-size: 11px;
    line-height: 140%;
    max-height: 0;
    margin-top: 5px;
    padding: 0px 10px;
    opacity: 0;
    transition: all 0.2s;

    &.shown {
        max-height: 2em;
        opacity: 1;
    }
`;
const BoxInputLabel = styled.label `
    ${({ theme, isActive, disabled }) => `
        ${isActive
    ? `
        font-size: 11px;
        top: 7px;
        left: 13px;
    `
    : `
        font-size: 15px;
        top: 14px;
        left: 13px;
    `}
        color: ${(() => {
    if (disabled) {
        return theme.colors.textBox.disabled.text;
    }
    else if (isActive) {
        return theme.colors.textBox.valid.text;
    }
    else {
        return theme.colors.textBox.inactive.text;
    }
})()}!important;
        pointer-events: none;
        position: absolute;
        transition: all 0.2s;
        white-space: nowrap;        
    `}
`;

export { BoxInputContainer, BoxInputError, BoxInputLabel, BoxInputOuterContainer, activateLabel };
